var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1015 32.2176L18.9894 32.3263C17.228 34.1209 15.1898 35.069 13.0903 35.069C8.70542 35.069 5.52455 31.7795 5.52455 27.2421C5.52455 22.7118 8.70542 19.417 13.0903 19.417C15.1898 19.417 17.228 20.3704 18.9894 22.172L19.1015 22.2789L21.9214 18.8685L21.846 18.7774C19.5011 16.0066 16.6865 14.6589 13.227 14.6589C9.7587 14.6589 6.58309 15.8278 4.29777 17.9326C1.80915 20.2144 0.5 23.4321 0.5 27.2421C0.5 31.0522 1.80915 34.2769 4.29777 36.5587C6.58309 38.6758 9.7587 39.8359 13.227 39.8359C16.6865 39.8359 19.5011 38.4865 21.846 35.714L21.9214 35.6298L19.1015 32.2176Z",
    fill: "#6A6F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7695 39.3672H29.7502V15.0489H24.7695V39.3672Z",
    fill: "#6A6F73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2638 34.0851C47.9336 34.8948 46.698 35.3031 45.5869 35.3031C43.9763 35.3031 43.2473 34.4514 43.2473 32.5586V19.6546H48.3244V15.077H43.2473V7.50949L38.3664 10.1243V15.077H34.1533V19.6546H38.3664V33.3806C38.3664 37.1187 40.5817 39.6775 43.8905 39.744C46.1355 39.7879 47.4884 39.1184 48.3086 38.6277L48.3612 38.5944L49.5582 33.9046L49.2638 34.0851Z",
    fill: "#6A6F73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3867 39.3672H58.3745V15.0489H53.3867V39.3672Z",
    fill: "#6A6F73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2795 10.7899C56.7282 4.344 49.1712 0.498918 41.4828 0.498918C33.7961 0.498918 26.2374 4.344 21.6948 10.7899L21.46 11.1211H27.1908L27.2539 11.0527C31.1533 7.0254 36.2462 4.89781 41.4828 4.89781C46.7194 4.89781 51.8088 7.0254 55.717 11.0527L55.78 11.1211H61.5074L61.2795 10.7899Z",
    fill: "#6A6F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiti);
export default __webpack_public_path__ + "static/media/citi.c6579fce6b3bed80845e08462a07b969.svg";
export { ForwardRef as ReactComponent };